import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { handleOnlyNumberAndPointer } from "utils/Utils";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import { parseAndSetFlag } from "utils/Utils";
import { collateralTypeList } from "assets/properties/properties";
import { isValidValue } from "utils/Utils";
const OrnamentCreate = ({ props, classes, featureFlag }) => {
    const navigate = useNavigate();
    const params = useParams();
    const showCollateralTypeFlag = parseAndSetFlag(featureFlag?.showCollateralType)
    const [ornamentName, setOrnamentName] = useState("");
    const [ornamentNameState, setOrnamentNameState] = useState(false);
    const [maxGross, setMaxGross] = useState("");
    const [maxGrossState, setMaxGrossState] = useState(false);
    const [minGross, setMinGross] = useState("");
    const [minGrossState, setMinGrossState] = useState(false);
    const [maxQuantity, setMaxQuantity] = useState("");
    const [maxQuantityState, setMaxQuantityState] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [isAcceptable, setAcceptable] = useState(true);
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [collateralTypeError, setCollateralTypeError]=useState(false);
  const [collateralType, setCollateralType]=useState("")
  const [callInProgress, setCallInProgress] = useState(false);
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (ornamentName === "") {
      setOrnamentNameState(true);
    } else {
        setOrnamentNameState(false);
    }
    if (minGross === "") {
      setMinGrossState(true);
    } else {
        setMinGrossState(false);
    }
    if (maxGross === "") {
      setMaxGrossState(true);
    } else {
        setMaxGrossState(false);
    }
    if (maxQuantity === "") {
      setMaxQuantityState(true);
    } else {
        setMaxQuantityState(false);
    }
    if(showCollateralTypeFlag && !isValidValue(collateralType)){
      setCollateralTypeError(true)
    }else{
      setCollateralTypeError(false)
    }
    if (ornamentName && minGross && maxGross && maxQuantity && ((showCollateralTypeFlag && isValidValue(collateralType)) || !showCollateralTypeFlag)) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if(params.ornamentId){
    GetData();
    }
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMET_GETDATA + params.ornamentId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setOrnamentName(result?.data?.name)
      setMinGross(result?.data?.minGrossWeight)
      setMaxGross(result?.data?.maxGrossWeight)
      setMaxQuantity(result?.data?.maxAllowedCount)
      setAcceptable(result?.data?.eligibility === "ACCEPTABLE" ? true : false)
      setIsActive(result?.data?.status === "ACTIVE" ? true : false)
      setCollateralType(result?.data?.collateralType)
    }
  };

  const updateRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.ORNAMENT_UPDATE + params?.ornamentId,
      method: "POST",
      authToken: authToken,
      data: {
        name: ornamentName,
        minGrossWeight: minGross,
        maxGrossWeight: maxGross,
        maxAllowedCount: maxQuantity,
        eligibility: isAcceptable ? "ACCEPTABLE" : "NON_ACCEPTABLE",
          ...(showCollateralTypeFlag && { collateralType }),
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const saveRoleInformation = async () => {
    setCallInProgress(true);
    const bulkData = {
      name: ornamentName,
      minGrossWeight: minGross,
      maxGrossWeight: maxGross,
      maxAllowedCount: maxQuantity,
      eligibility: isAcceptable ? "ACCEPTABLE" : "NON_ACCEPTABLE",
      ...(showCollateralTypeFlag && { collateralType }),
    };
    const res = await apiHandler({
      url: endpoint.ORNAMENT_CREATE,
      method: "POST",
      authToken: authToken,
      data: bulkData,
      ...(showCollateralTypeFlag && { collateralType }),
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
const handleroleSubmit = async (event) => {
  if (isValidated()) {
    toastUpdate("", "", false);
    let status = "";
    if (params.ornamentId) {
      status = await updateRoleInformation();
    } else {
      status = await saveRoleInformation();
    }
    if (status === "SUCCESS") {
      const msg = params.ornamentId
        ? "Ornament updated successfully!"
        : "Ornament created successfully!";
        toastUpdate("Success", msg, true);
      setRedirectURL(`/coreservice/ornament`);
    }
  }
};

const handleStatusChange = async (operation, status, elegiblity) => {
  setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_STATUS_UPDATE + params?.ornamentId,
      method: "PATCH",
      authToken: authToken,
      data: {
        operation: operation,
        value: {
          status: status ? status :  isActive ? "ACTIVE" : "INACTIVE",
          eligibility: elegiblity ? elegiblity : isAcceptable ? "ACCEPTABLE" : "NON_ACCEPTABLE"
        }
      },
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      console.log()
    }
};

  const statusUpdate = async(checked)=>{
    
    const status = checked === false ? "INACTIVE" : "ACTIVE"
    setIsActive(checked)
    if(params.ornamentId){
      handleStatusChange("status", status)
    }
  }

  const AcceptableUpdate = (checked)=>{
    const status = checked === true ? "ACCEPTABLE" : "NON_ACCEPTABLE"
    setAcceptable(checked)
    if(params.ornamentId){
      handleStatusChange("eligibility", "", status)
    }
  }
  const handlecancelrole = () => {
    navigate("/coreservice/ornament");
  };

  const handleChange = (e,name) => {
    const regex = /^[0-9\b]+$/;
      if ((e === "" || regex.test(e)) && name==="minGross" ) {
        setMinGross(e);
      }
      if ((e === "" || regex.test(e)) && name==="maxGross" ) {
        setMaxGross(e);
      }
      if ((e === "" || regex.test(e)) && name==="maxQuantity" ) {
        setMaxQuantity(e);
      }
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.ornamentId ? "Edit Ornament" : "Create Ornament"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleroleSubmit}
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {showCollateralTypeFlag && <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Collateral Type"
              required
              error={collateralTypeError}
              value={collateralType}
              setState={setCollateralType}
              data={collateralTypeList}
              setError={setCollateralTypeError}
            />
          </Grid>}
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Ornament Name"
              required
              error={ornamentNameState}
              id="lp_min_role"
              value={ornamentName || ""}
              setState={setOrnamentName}
              setError={setOrnamentNameState}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Minimum Gross Weight (in gms)"
              required
              error={minGrossState}
              id="lp_min_role_name"
              value={minGross || ""}
              setState={(e) => handleOnlyNumberAndPointer(e, setMinGross)}
              setError={setMinGrossState}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Maximum Gross Weight (in gms)"
              required
              error={maxGrossState}
              id="lp_min_role_name"
              value={maxGross || ""}
              setState={(e) => handleOnlyNumberAndPointer(e, setMaxGross)}
              setError={setMaxGrossState}
            />
          </Grid>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Maximum Quantity Allowed (in Count)"
              required
              error={maxQuantityState}
              id="lp_min_role_name"
              value={maxQuantity || ""}
              setState={(e)=>handleChange(e,"maxQuantity")}
              setError={setMaxQuantityState}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <p style={{ fontWeight: "bold" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={isActive}
                  className={classes.checkboxInput}
                  onChange={(e) => statusUpdate(e.target.checked)}
                />{" "}
                Active
              </p>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <p style={{ fontWeight: "bold" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={isAcceptable}
                  className={classes.checkboxInput}
                  onChange={(e) => AcceptableUpdate(e.target.checked)}
                />{" "}
               Acceptable
              </p>
              </Grid>
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default OrnamentCreate;
